import React, { FC } from "react";
// libs
import dynamic from "next/dynamic";
// components
const SearchSection = dynamic(import("src/components/containers/home/sections/Search/Search"), {
  ssr: true,
});
const ServicesSection = dynamic(import("src/components/containers/home/sections/Service/Service"), {
  ssr: true,
});
const AppointmentSection = dynamic(
  import("src/components/containers/home/sections/Appointment/Appointment"),
  { ssr: true },
);
const ReviewsSection = dynamic(import("src/components/containers/home/sections/Reviews/Reviews"), {
  ssr: true,
});
const FindClinicsSection = dynamic(
  import("src/components/containers/home/sections/FindClinic/NewFindClinics/FindClinics"),
  { ssr: true },
);
const RegisterPetSection = dynamic(
  import("src/components/containers/home/sections/RegisterPet/RegisterPet"),
  { ssr: true },
);
// types
import { IReviewsComponent } from "src/components/containers/home/sections/Reviews/Reviews";
import { ISearchSection } from "src/components/containers/home/sections/Search/Search";
import { IServiceSection } from "src/components/containers/home/sections/Service/Service";

interface IHomeContainer {
  searchSection: ISearchSection;
  servicesSection: IServiceSection;
  reviewsSection: IReviewsComponent;
  clinicsByCity: any;
}

const HomeContainer: FC<IHomeContainer> = ({
  searchSection,
  servicesSection,
  reviewsSection,
  clinicsByCity,
}) => {
  return (
    <>
      <SearchSection {...searchSection} />
      <ServicesSection {...servicesSection} />
      <AppointmentSection />
      <ReviewsSection {...reviewsSection} />
      <FindClinicsSection cities={clinicsByCity} />
      <RegisterPetSection />
    </>
  );
};

export default HomeContainer;
